/**
 * Generic Wizard Component
 * Main entry point for wizard functionality
 */

import { WizardProvider } from './WizardContext';
import WizardLayout from './WizardLayout';
import { WizardProps } from './types';

/**
 * Generic Wizard Component
 * Provides a full-screen multi-step form wizard
 *
 * @example
 * ```tsx
 * const config = createWizardConfig();
 * <Wizard
 *   clientId="123"
 *   clientName="John Doe"
 *   config={config}
 *   initialData={prefillData}
 *   onClose={() => navigate('/')}
 * />
 * ```
 */
export function Wizard<T = any>({
  clientId,
  clientName,
  config,
  initialData,
  onClose,
  reviewMode = false
}: WizardProps<T>) {
  return (
    <WizardProvider
      clientId={clientId}
      clientName={clientName}
      config={config}
      initialData={initialData}
      reviewMode={reviewMode}
    >
      <WizardLayout
        clientName={clientName}
        onClose={onClose}
      />
    </WizardProvider>
  );
}

export default Wizard;
